module.exports = __webpack_public_path__ + "33bfb2c3e44eaec22f694cdf3e85aac3.pdf";